import React from 'react';
import { Link } from "react-router-dom";


export const TO_DATE = 'toDate';
export const FROM_DATE = 'fromDate';
export const REQUEST_BODY = {
    pageNumber: 0,
    pageSize: 100,
    sortField: 'createdAt',
    sortDirection: 'DESC'
}

export const PARTIAL_FAILURE = 'PARTIAL_FAILURE';
export const PROCESSING = 'PROCESSING';
export const PENDING = 'PENDING'
export const ENTER = 'Enter';